	// Animation Formulaire contact.html
	$('input').focus(function(){
		$(this).parents('.form-group').addClass('focused');
	  });
	  
	  $('input').blur(function(){
		var inputValue = $(this).val();
		if ( inputValue == "" ) {
		  $(this).removeClass('filled');
		  $(this).parents('.form-group').removeClass('focused');  
		} else {
		  $(this).addClass('filled');
		}
	  })

	  $(document).ready(function(){
$("review-widget").show();
		// console.log('ok');
	  //Scroll to
	  	$( "a.scrolldown" ).on('click',function( event ) {
				var offsetvalue = $(this).attr("data-offset");
				event.preventDefault();
				$("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top - offsetvalue}, 700);
		});
		if($('body').hasClass('presentation')){
		  if(window.innerWidth > 767){
			initSlider(); 
		  } else{
			$('body').addClass('noslider');
		  }
		}

		initVideoModal();
	  });

function initSlider(){
	const leftArticles = document.querySelectorAll('.presentation-left article');
	const rightArticles = document.querySelectorAll('.presentation-right article');
	let sliding = false;
	let currentSlide = 1;
	let scrollY = 0;
	const slideNumber = (leftArticles.length) + (rightArticles.length)
	const windowHeight = window.innerHeight;
	const offset = (document.querySelector('header').offsetHeight + (windowHeight - leftArticles[0].offsetHeight/2)) - windowHeight - windowHeight * 0.4;
	const sliderBackground = document.getElementById('presentation-bg');
	const sliderBackgroundBis = document.getElementById('presentation-bg-tigre');
	const scrollDown = document.getElementById('scrollDown');
	let scrollDownTO;
  
	let bgPos = 0;
	spaceArticles();
  
	window.addEventListener("scroll", function(e) {
	  scrollY = window.scrollY - offset;
	  currentSlide = Math.min(Math.round(scrollY / windowHeight), slideNumber);
	  
	  showArticle();
	  scrollBackground();
	},false)
  
	function showArticle(){
	  if(currentSlide > 0){
		if (currentSlide%2 == 0 && currentSlide){
		  leftArticles.forEach((el) => {
			el.classList.remove('show');
		  });
		  rightArticles[(currentSlide/2)-1].classList.add('show');
		}
		else{
		  rightArticles.forEach((el) => {
			el.classList.remove('show');
		  })
		  leftArticles[((currentSlide + 1)/2)-1].classList.add('show');
		}
	  }
  
	  clearTimeout(scrollDownTO);
	  scrollDown.classList.remove('animate');
	  scrollDownTO = setTimeout(function(){
		scrollDown.classList.add('animate');
	  }, 1000);
	}
  
	function scrollBackground(){
	  bgPos = (scrollY + offset) / 5;
	  sliderBackground.style.backgroundPositionY =  -bgPos + 'px';
	  sliderBackgroundBis.style.backgroundPositionY =  -(bgPos/4) + 'px';
	}
  
	function spaceArticles(){
	  setTimeout(function(){
		leftArticles[0].classList.add('show');
	  },200)
	  leftArticles.forEach((el) => {
		el.style.marginTop =  (windowHeight - el.offsetHeight/2) + "px";
		el.style.marginBottom =  (windowHeight - el.offsetHeight/2) + "px";
	  })
	  
	  rightArticles.forEach((el) => {
		el.style.marginTop =  (windowHeight - el.offsetHeight/2) + "px";
		el.style.marginBottom =  (windowHeight - el.offsetHeight/2) + "px";
	  })
	}
  }

  function initVideoModal(){
	const modal = document.getElementById('modalvideo');
	const modalTrigger = document.getElementById('modalvideoTrigger');
	const modalTriggerBack = document.getElementById('modalvideoTriggerBack');

	console.log(modal, modalTrigger);

	modalTrigger.addEventListener('click', () => {
		modal.classList.add('show')
	})

	modalTriggerBack.addEventListener('click', () => {
		modal.classList.remove('show')
	});
  }

  console.log('okkk')